module.exports = __webpack_public_path__ + "static/media/sortrightLogo.ab868328.png";